// extracted by mini-css-extract-plugin
export default {"overflow_x_hidden_container":"Home_overflow_x_hidden_container__jGYti","home":"Home_home__SzkB-"};